import React, { Component } from "react";
import { connect } from "react-redux";
import { Link } from "react-router-dom";
import DarkOverlay from "../../../Parts/DarkOverlay";
import Price from "../../../Parts/Price";
import { toggleATCConfirmation } from "../../../Redux/slices/singleProduct";

const mapStateToProps = state => {
    return {
        productSize: state.singleProduct.activeVariation.value,
        productPrice: state.singleProduct.activeVariation.price,
        visible: state.singleProduct.UI.showATCConfirmation,
        cartTotal: state.cart.totals.total,
        mediaType: state.appSettings.mediaType
    }
}

class AddedTC extends Component {
    render() {
        var desktopTransformClass = "";
        if (this.props.mediaType === "desktop") {
            desktopTransformClass = " fade-y-top";
        }

        return <DarkOverlay visible={this.props.visible} closeSelf={toggleATCConfirmation}>
        <div className={"atc-confirmation transform-fade-y" + desktopTransformClass}>
            <div className="head-wrap">
                <span>Added to cart!</span>
            </div>

            <div className="content">
                <div className="item-wrap">
                    <img src={this.props.image} />
                    <div className="item-details">
                        <span className="title">{this.props.title}</span>
                        <span className="size-price">
                            <span className="size">{this.props.productSize}</span>
                            <span className="separator">|</span>
                            <Price className="price">{this.props.productPrice}</Price>
                        </span>
                    </div>
                </div>

                <div className="btn-wrap">
                    <Link className="btn" to="/">Continue shopping</Link>
                    <a className="btn" href="/checkout">Go to checkout</a>
                </div>

                <span className="cart-total">Cart total is <Price className="total">{this.props.cartTotal}</Price></span>
            </div>
        </div>
    </DarkOverlay>
    }
}

export default connect(mapStateToProps)(AddedTC);